<template>
  <div class="left-bar">
    <div class="left-top-bar">
      <div :class="classObject"></div>
      <div class="user-type-name">
        <div class="div-name" :title="userInfo.name">{{userInfo.name}}</div>
        <div class="user-rolename">{{userInfo.roleNames}}</div>
      </div>
    </div>
    <el-menu theme="dark" :default-active="onRoutes" unique-opened router>
      <template v-for="item in menuInfo">
        <template v-if="item.children">
          <el-submenu :index="item.id" :key="item.id">
            <template slot="title"><i class="el-icon-fa-users"></i>{{ item.name }}</template>
            <el-menu-item v-for="(subItem,i) in item.children" :key="i" :index="subItem.permission" :route="{name: subItem.permission}">{{ subItem.name }}
            </el-menu-item>
          </el-submenu>
        </template>
      </template>
      <el-submenu :index="'account'">
        <template slot="title"><i class="el-icon-fa-id-card"></i>账号设置</template>
        <el-menu-item :route="{name: 'baseInfo'}" :index="'baseInfo'">
          基本信息
        </el-menu-item>
        <el-menu-item :route="{name: 'passManage'}" :index="'passManage'">
          密码修改
        </el-menu-item>
      </el-submenu>
    </el-menu>
    <span class="version">版本：{{verison}}</span>
  </div>
</template>
<script>
  export default {
    name: 'sidebar',
    computed: {
      classObject: function() {
        return {
          'common-icon': true,
          'user-icon': this.userInfo.orgType === '225',
          'manage-icon': this.userInfo.orgType < '224',
          'xz-icon': this.userInfo.orgType === '224',
        }
      },
      onRoutes() {
        return this.$route.name;
      },
      verison() {
        return this.$store.getters.objApi.VERSION
      }
    },
    data() {
      return {
        userInfo: this.$store.getters.userInfo,
        menuInfo: this.$store.getters.menuInfo
      };
    }
  }
</script>
<style lang="less" rel="stylesheet/less" scoped>
  @base-bg: #00A0E9;
  @submenu-bg: #1D8CE0;
  .left-bar {
    min-height: 100%;
    color: #fff;
    background: url('../../assets/img/nav-bottom.jpg') center bottom no-repeat @base-bg;
    .version {
      position: absolute;
      bottom: 17px;
      left: 46px;
      color: #e0e0e0;
    }
    .left-top-bar {
      padding: 16px 0 8px 0;
      text-align: center;

      .common-icon {
        width: 70px;
        height: 70px;
        margin: 0 auto;
        border: 2px solid #fff;
        border-radius: 35px;
      }

      .user-icon {
        background: url('../../assets/img/icon-user-group.png') -70px -70px no-repeat;
      }
      .manage-icon {
        background: url('../../assets/img/icon-user-group.png') -70px 0 no-repeat;
      }
      .sy-icon {
        background: url('../../assets/img/icon-user-group.png') 0 0 no-repeat;
      }
      .xz-icon {
        background: url('../../assets/img/icon-user-group.png') 0 -70px no-repeat;
      }
      .user-type-name {
        margin-top: 10px;
        .user-rolename {
          font-size: 12px;
          color: #b3e3f8;
          line-height: 28px;
        }
      }
    }
    .el-menu--dark {
      background: #1d8ce0;
    }

    .el-menu > li, .el-menu > a > li {
      border-bottom: 1px solid @base-bg;
    }

    .el-menu-item.is-active {
      color: #fad67f;
    }

    .custom-icon {
      vertical-align: baseline;
      margin-right: 12px;
      display: inline-block;
      width: 20px;
      height: 20px;
      position: relative;
      top: 3px;
    }

  }
  .hideSidebar .title-link {
    display: inline-block;
    padding-left: 10px;
  }
  .div-name {
    font-size: 14px;
    padding: 0 40px;
    height: 16px;
    line-height: 16px;
    overflow: hidden;
  }
</style>
<style>
  .el-menu--dark .el-submenu .el-menu {
    background-color: #00a0e9;
  }
  .el-menu--dark .el-menu-item, .el-menu--dark .el-submenu__title {
    color: #fff;
  }
  .el-menu--dark .el-submenu .el-menu .el-menu-item:hover, .el-menu--dark .el-menu-item:hover, .el-menu--dark, .el-submenu__title:hover, .el-menu--dark .el-submenu__title:hover {
    background-color: #58b7ff;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue